import { Button } from './ui/Button';
import { useSpyScan } from '../hooks/useSpyScan';

interface ScanForSpiesButtonProps {
    planetId: string | undefined;
    intelligenceLevel: number;
    lastSpyScanAt?: Date;
    /** Wrapper layout — the Planet page stacks it in a button row, the Sciences page in its own section. */
    className?: string;
}

/** "Scan for Spy Ships" control + its result line, shared by the Planet and Sciences pages. */
export default function ScanForSpiesButton({
    planetId,
    intelligenceLevel,
    lastSpyScanAt,
    className,
}: ScanForSpiesButtonProps) {
    const { scan, message, disabled, label } = useSpyScan(planetId, intelligenceLevel, lastSpyScanAt);

    return (
        <div className={`flex flex-col gap-1 ${className ?? ''}`}>
            <Button
                onClick={() => { scan().catch(() => { }); }}
                disabled={disabled}
                data-testid="scan-for-spies-button"
                data-tutorial-id="planet-scan-for-spies"
                variant="secondary"
                size="sm"
                className="self-start"
            >
                {label}
            </Button>
            {message && (
                <p className="text-content-secondary text-body" data-testid="scan-for-spies-result">{message}</p>
            )}
        </div>
    );
}
